// extracted by mini-css-extract-plugin
module.exports = {"custom":"buttonSuccess_custom__1g1uc"};